import { Space as AntdSpace } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TaskId } from 'api/models';
import { LinkToTask } from 'components/atoms/link-to-task';
import { ListWithLink } from 'components/atoms/list-with-links';
import { Task } from 'stores/tasks';
import { DueBy } from '../../../style';

const Space = styled(AntdSpace)`
  &&& .ant-space-item:first-child {
    max-width: 100%;
    flex: 1;
  }
`;

export const DataContent: FC<{ data: Task[] }> = ({ data }) => {
  return (
    <ListWithLink
      dataSource={data}
      renderItem={(item) => {
        return (
          <ListWithLink.Item>
            <LinkToTask id={TaskId(item.project, item.taskId)}>
              <Space>
                {item.taskName}
                <DueBy>
                  <FormattedMessage
                    id="relative_date"
                    values={{
                      diff: moment().diff(moment(item.dueDate), 'days'),
                    }}
                  />
                </DueBy>
              </Space>
            </LinkToTask>
          </ListWithLink.Item>
        );
      }}
    />
  );
};
